export default __webpack_public_path__ + "static/media/coffee.8b405143.jpg";